import {Component, Input, OnInit} from "@angular/core";
import {I18nServices} from "@aparraga/ahoracrypto-client-common/src/app/common/i18n/i18n.service";
import {ContentControllerService} from "@aparraga/ahoracrypto-api-sdk/sdk/api/contentController.service";

@Component({
    templateUrl: './contentbox.component.html',
    styleUrls: ['./contentbox.component.scss'],
    selector: 'contentbox',
    standalone: false
})
export class ContentBoxComponent implements OnInit {

  @Input('contentId') contentId: string;

  @Input('useDefaultLanguage') useDefaultLanguage = true;
  @Input('defaultLanguage') defaultLanguage: string = 'en';

  public content;

  public constructor(protected i18nServices: I18nServices,
                     protected contentControllerService: ContentControllerService) {

  }

  public ngOnInit(): void {

    let languageIsoCode = this.i18nServices.getLanguageIsoCode();

    if(this.contentId != null && languageIsoCode != null) {
      this.contentControllerService.contentControllerFindByCodeAndLanguageIsoCode(this.contentId, languageIsoCode).subscribe(content => {
        if (content != null && content != 'null') {
          this.content = content;
        }
        else if(this.useDefaultLanguage != null && this.useDefaultLanguage && this.defaultLanguage != null && this.defaultLanguage != languageIsoCode) {
          this.contentControllerService.contentControllerFindByCodeAndLanguageIsoCode(this.contentId, this.defaultLanguage).subscribe(content => {
            if (content != null && content != 'null') {
              this.content = content;
            }
          });
        }
      });
    }

  }


}
